module.exports = __webpack_public_path__ + "img/portraits_16_V.eb634613.jpg";